import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from 'environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class GoogleMapsApiService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  public loadGoogleMapsApi(): Observable<object> {
    return this.http.jsonp(
      `https://maps.googleapis.com/maps/api/js?key=${env.googleApiKey}&libraries=places`,
      'callback',
    );
  }
}
